import { render, staticRenderFns } from "./LINK_PARA_ACAO.vue?vue&type=template&id=3552db9e"
import script from "./LINK_PARA_ACAO.vue?vue&type=script&lang=js"
export * from "./LINK_PARA_ACAO.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports